var React = require('react');

function CursorLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.561 7.049a2 2 0 011.111.067l24.524 8.758a2 2 0 01.744 3.296l-5.176 5.176L41.35 35.931a2 2 0 010 2.828l-2.586 2.586a2 2 0 01-2.828 0L24.35 29.762l-5.18 5.18a2 2 0 01-3.296-.744L7.117 9.673a2 2 0 011.445-2.624zM9 9l8.758 24.524 5.885-5.885a1 1 0 011.414 0L37.35 39.931l2.586-2.586-12.292-12.292a1 1 0 010-1.414l5.881-5.88L9 9z"}));
}

CursorLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CursorLight;

CursorLight.default = CursorLight;
